<template>
    <resource-link
        v-if="urn"
        :urn="urn"
        :menu-items="menuItems"
        :data-cy="`subacc-link-${uuid}`"
    >
        <slot/>
    </resource-link>
    <span
        v-else
        :data-cy="`subacc-link-${uuid}`"
    >
        <slot/>
    </span>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {useTargetingLinkService} from '@tritt/multipanel'
import {useInvoiceCreator} from '@/invoice/invoice.service'
import {usePanelManager} from '@tritt/multipanel'
import {INVOICE_CREATOR} from '@/invoice'
import {findSubAccountByUuid, useSubAccounts} from '@/subaccount/subAccount.service'
import {IContextMenuItem} from '@tritt/multipanel'
import {getExternalSubAccountSearchContextMenuItems} from '@/subaccount/subAccountExternalSearches'
import ResourceLink from '@/resource-link/ResourceLink.vue'
import {selectedOrg} from '@/tenants/org.service'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const {customers} = useSubAccounts()

const subAccount = computed(() => findSubAccountByUuid(props.uuid))
const subAccountName = computed(() => subAccount.value?.name)

const isCustomer = computed(() => customers?.value.some(c => c.uuid === props.uuid))

const urn = computed(() => {
    if (!selectedOrg.value) {
        return undefined
    }
    return {
        system: 'pracsys',
        type: 'sub_account',
        identifier: props.uuid,
        display: subAccountName.value,
        tenantId: selectedOrg.value.organizationId
    }
})

const showInvoiceCreator = () => {
    const {targetPanel} = useTargetingLinkService()
    const {customer} = useInvoiceCreator()
    const subAccount = findSubAccountByUuid(props.uuid)
    if (subAccount) {
        customer.value = subAccount
    }
    const {setPanelPath} = usePanelManager()
    setPanelPath({
        ...INVOICE_CREATOR,
        panelId: targetPanel.value ?? undefined
    })
}

const menuItems = computed(() => {
    const mItems: IContextMenuItem[] = []

    if (isCustomer.value) {
        mItems.push({
            label: 'Lag ny faktura',
            ['data-cy']: 'cm-new-invoice-button',
            onSelect: showInvoiceCreator
        })
    }

    mItems.push({type: 'separator'})
    mItems.push({
        label: 'Eksterne søk',
        children: [
            {
                label: 'Søk på ' + subAccountName.value,
                type: 'label'
            },
            {
                type: 'separator'
            },
            ...getExternalSubAccountSearchContextMenuItems(subAccount.value)
        ]
    })

    return mItems
})

</script>

<style scoped>

</style>